import React, { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import SummaryApi from '../common'
import AdminVerticalCard from '../components/AdminVerticalCard'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import ROLE from '../common/role'
import { AiOutlineLoading3Quarters } from 'react-icons/ai'


const AdminSearchProduct = () => {
    const query = useLocation()
    const [data,setData] = useState([])
    const [loading,setLoading] = useState(false)
    const user = useSelector(state => state?.user?.user);
    const navigate = useNavigate();


    const fetchProduct = async()=>{
        setLoading(true)
        const response = await fetch(SummaryApi.searchProduct.url+query.search)
        const dataResponse = await response.json()
        setLoading(false)

        setData(dataResponse.data||[])
    }


    useEffect(() => {
      setLoading(true);
      const loadingTimeout = setTimeout(() => {
        
        setLoading(false);
        navigate("/");
      }, 10000); 
  
      if (user) {
        if (user?.role !== ROLE.ADMIN ) {
          
          navigate("/");
          setLoading(false);
        } 
        else if(user?.type==="Cosmetic"){
          navigate('/admin-cosmetic-home')
          setLoading(false);
  
        }
        else if(user?.type==="Admin"){
          navigate('/admin-panel/all-users');
          setLoading(false);
  
        }
        else {
          setLoading(false);
          clearTimeout(loadingTimeout)
          fetchProduct();
        }
      } 
  
      // Clear the timeout when the component unmounts or the effect is rerun
      return () => clearTimeout(loadingTimeout);
    }, [query,user, navigate]);
  
    
    if (loading) {
      return (
        <div className="flex justify-center items-center h-screen">
          <AiOutlineLoading3Quarters className="animate-spin text-6xl text-blue-500" />
        </div>
      );
    }
  

  return (
    <div className='container mx-auto p-4'>
      {
        loading && (
          <p className='text-lg text-center'>... تحميل</p>
        )
      }
 
      <p className='text-lg font-semibold my-3 text-right'>نتائج البحث : {data.length}</p>

      {
        data.length === 0 && !loading && (
           <p className='bg-white text-lg text-center p-4'>لا يوجد لدينا منتج بهذا الاسم</p>
        )
      }


      {
        data.length !==0 && !loading && (
          <AdminVerticalCard userType={"Medicine"} loading={ loading} data={data}/>
        )
      }

    </div>
  )
}

export default AdminSearchProduct